import {Navigate, useParams, useSearchParams} from "react-router-dom";
import {useFetch} from "../helpers/APIHelper";
import {getRelativeUrl} from "./Property/PropertyHelper";
import {RoutingHelper} from "./Navigation/Routing";

function Redirect(){
    const [searchParams] = useSearchParams();
    const {promotionref} = useParams();

    const isProperty = window.location.pathname.includes("propriete");
    const isPromotion = window.location.pathname.includes("promotion");

    let ref = "";
    let endpoint = "";

    if(isPromotion){
        ref = promotionref;
        endpoint = "promotions";
    }
    if (isProperty) {
        ref = searchParams.get("ref");
        endpoint = "properties";
    }

    const {data, loading, error} = useFetch({endpoint: `/${endpoint}/${ref.toUpperCase()}`});

    if (isProperty || isPromotion) {
        if (!loading && !error && data?.data !== null) {
            return (<Navigate to={getRelativeUrl(data.data, isPromotion, promotionref)} replace={true}/>);
        }
        else if (error || data?.data === null) {
            return (<Navigate to={RoutingHelper.getPath("home")} replace={true}/>);
        }
    }
    else{
        return (<Navigate to={RoutingHelper.getNewPath(window.location.pathname)} replace={true}/>);
    }
}

export default Redirect;